module.exports = __webpack_public_path__ + "static/img/santacruz.198b4dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/departamentales/santacruz.png
// module id = eo1+
// module chunks = 1